module.exports = __webpack_public_path__ + "img/20191120162443360截图20191120161409646.332931a2.jpg";